import { jsx as _jsx } from "react/jsx-runtime";
/// <reference types="@welldone-software/why-did-you-render" />
// Import Habla styles early so that local style can override them if needed
import '@dixa/lib-shared-habla/style.css';
import { ErrorBoundaryContext, TooltipProvider } from '@dixa/lib-shared-habla';
import { setAutoFreeze } from 'immer';
// eslint-disable-next-line no-restricted-imports
import React from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { unstable_HistoryRouter as UnstableHistoryRouter } from 'react-router-dom';
import { AppRoutes } from 'app/app.routes';
import { patchAgainstGoogleTranslateInterferingWithReactDOM } from 'app/utils/googleTranslateWorkaround';
import { Sentry, sentryInit } from 'app/utils/sentry';
import { history, store } from 'store';
import { localeInit } from 'utils/i18n';
import AudioManager from './assets/app/utils/audioManager';
// eslint-disable-next-line dixa/no-cross-reference-imports, no-restricted-imports
import 'assets/styles/less/main.less';
// TODO [TEAMS-8570]: Turn this into scss and remove unused the styles. The
// styles are scoped to a `settings-page` class on the column, so that the
// styles don't bleed out to the rest of the application. This will eventually
// have to be removed.
// eslint-disable-next-line dixa/no-cross-reference-imports, no-restricted-imports
import 'assets/components/settings/styles/settings.less';
if (process.env.NODE_ENV === 'development') {
    // We only import wdyr package on development, hence need the var require.
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const whyDidYouRender = require('@welldone-software/why-did-you-render');
    whyDidYouRender(React);
}
localeInit();
sentryInit();
// Run before rendering the app, but after Sentry is initialized.
patchAgainstGoogleTranslateInterferingWithReactDOM('warning');
// immer@8 automatically freezes any state trees that are modified using
// `produce`. This reverts to the older behavior, where auto-freezing is not
// enabled in production.
setAutoFreeze(process.env.NODE_ENV !== 'production');
// Sets the store for the audio manager.
AudioManager.setStore(store);
// Listens to history state changes and logs to analytics.
history.listen(() => {
    var _a, _b;
    (_b = (_a = window.analytics) === null || _a === void 0 ? void 0 : _a.page) === null || _b === void 0 ? void 0 : _b.call(_a);
});
/**
 * Handles Logging the error to Sentry.
 *
 * @param error The error from the error boundary.
 */
const handleError = (error) => {
    Sentry.captureException(error);
};
ReactDOM.render(_jsx(Provider, Object.assign({ store: store }, { children: _jsx(ErrorBoundaryContext.Provider, Object.assign({ value: { onError: handleError } }, { children: _jsx(TooltipProvider, { children: _jsx(DndProvider, Object.assign({ backend: HTML5Backend }, { children: _jsx(UnstableHistoryRouter, Object.assign({ history: history, basename: BASEPATH }, { children: _jsx(AppRoutes, {}) })) })) }) })) })), document.getElementById('app'));
